import { useEffect } from 'react';
import { useStore } from 'hooks/useStore';
import { notify } from 'components-stateless/Notifications';

const ZustandNotificationHandler = () => {
  const isCloseable = useStore((state) => state.notificationSlice.isCloseable);
  const message = useStore((state) => state.notificationSlice.message);
  const type = useStore((state) => state.notificationSlice.type);
  const showNotification = useStore(
    (state) => state.notificationSlice.showNotification
  );
  const hideNotification = useStore(
    (state) => state.notificationSlice.hideNotification
  );
  const actionButtonText = useStore(
    (state) => state.notificationSlice.actionButtonText
  );
  const onClickActionButton = useStore(
    (state) => state.notificationSlice.onClickActionButton
  );

  useEffect(() => {
    if (showNotification) {
      notify({
        message,
        isCloseable,
        type,
        actionButtonText,
        onClickActionButton,
        onClose: hideNotification,
      });
    }
  }, [
    message,
    showNotification,
    hideNotification,
    isCloseable,
    type,
    actionButtonText,
    onClickActionButton,
  ]);

  return null;
};

export { ZustandNotificationHandler };
